<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Se connecter en tant que   </strong>
      </b-card-header>
      <b-card-body>
        <b-form-group label-for="role">
          <label for="role"><strong>role</strong></label>
          <b-form-select
            id="role"
            :plain="true"
            :options="roleOptions"
            :class="{hasError: errors.role !== ''}"
            v-model="selectedRole">
          </b-form-select>
          <span class="field-error">{{ errors.role }}</span>
        </b-form-group>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../utils/auth";

  export default {
    name: "LoginAs",
    data() {
      return {
        roles: [],
        roleOptions: [],
        selectedRole: '',
        errors: {
          role: '',
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl()
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common["Accept"] = "application/json"
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getRoles();
    },
    methods: {
      getRoles() {
        this.$axios
          .get("/administration/profiles")
          .then(response => {
            this.roles = response.data.data;
            console.log(this.roles);
            for (let i = 0; i < this.roles.length; i++) {
              this.roleOptions.push({
                text: this.roles[i].libelle,
                value: this.roles[i].id
              });
            }
          });
      },
    }
  }
</script>

<style scoped>

</style>
